import { BaseLayout, type NavSection } from './BaseLayout';
import {
  LayoutDashboard, ClipboardList, GraduationCap, Users, Megaphone, Settings,
  Award, BookOpen, BarChart3, NotebookPen, MessageSquare, User, Bell,
} from 'lucide-react';
import { useProfessorNavBadges } from '../../hooks/useProfessorNavBadges';
import { useProfileBrandColor } from '../../theme/useProfileBrandColor';

const NAV_SECTIONS: NavSection[] = [
  {
    title: 'Dia a Dia',
    items: [
      { to: '/professor/dashboard', label: 'Dashboard', icon: LayoutDashboard, badgeKey: 'dashboard' },
      { to: '/professor/chamada', label: 'Chamada', icon: ClipboardList, badgeKey: 'chamada' },
      { to: '/professor/diario', label: 'Diário de Classe', icon: NotebookPen, badgeKey: 'diario' },
      { to: '/professor/comunicados', label: 'Comunicados', icon: Megaphone, badgeKey: 'comunicados' },
      { to: '/professor/conversas-pais', label: 'Atendimento (Pais)', icon: MessageSquare, badgeKey: 'chat' },
      { to: '/professor/ead', label: 'Vídeo Aulas', icon: GraduationCap },
    ],
  },
  {
    title: 'Pedagógico',
    items: [
      { to: '/professor/turmas', label: 'Minhas Turmas', icon: GraduationCap, badgeKey: 'turmas' },
      { to: '/professor/alunos', label: 'Meus Alunos', icon: Users, badgeKey: 'alunos' },
      { to: '/professor/avaliacoes', label: 'Avaliações', icon: Award, badgeKey: 'avaliacoes' },
      { to: '/professor/observacoes', label: 'Observações', icon: BookOpen, badgeKey: 'observacoes' },
    ],
  },
  {
    title: 'Análise',
    items: [
      { to: '/professor/relatorios', label: 'Relatórios', icon: BarChart3, badgeKey: 'relatorios' },
    ],
  },
  {
    title: 'Minha Conta',
    items: [
      { to: '/professor/perfil', label: 'Meu Perfil', icon: User, badgeKey: 'perfil' },
      { to: '/professor/alertas', label: 'Meus Comunicados', icon: Megaphone, badgeKey: 'alertas' },
    ],
  },
];

export function ProfessorLayout() {
  const badges = useProfessorNavBadges();
  const { brandColor, brandGradient } = useProfileBrandColor('PROFESSOR');

  return (
    <BaseLayout
      sections={NAV_SECTIONS}
      headerTitle="Painel Professor"
      brandColor={brandColor}
      brandGradient={brandGradient}
      badges={badges}
      navSize="md"
    />
  );
}
